import React, { useState } from 'react';
import { Box } from '@mui/material';
import OnboardingStepPassword from '../../components/onboarding/OnboardingStepPassword';
import OnboardingStepRoles from '../../components/onboarding/OnboardingStepRoles';
import OnboardingStepSchulstufe from '../../components/onboarding/OnboardingStepSchulstufe';
import OnboardingStepSchulfaecher from '../../components/onboarding/OnboardingStepSchulfaecher';
import OnboardingStepWichtigkeit from '../../components/onboarding/OnboardingStepWichtigkeit';
import OnboardingStepBundesland from '../../components/onboarding/OnboardingStepBundesland';
import OnboardingStepSchule from '../../components/onboarding/OnboardingStepSchule';
import useScreenSize from '../../utils/useScreenSize';
import useRouter from '../../utils/useRouter';
import { Option } from '../../components/onboarding/OnboardingOptionChipList';

export interface OnboardingSteps {
  password: string;
  roles: string;
  schule: string;
  schulstufe: string;
  schulfaecher: string;
  wichtigkeit: string;
  bundesland: string;
}

const OnboardingPage: React.FC = () => {
  const { isLgScreen, isMdScreen } = useScreenSize();
  const isDesktopScreen = isLgScreen || isMdScreen;
  const [initialSelectedSubjects, setInitialSelectedSubjects] = useState<Option[]>([]);
  const { match } = useRouter();
  const { query } = match.location;
  const initialStep = query.step as keyof OnboardingSteps || 'password';
  const [onboardingStep, setOnboardingStep] = useState<keyof OnboardingSteps>(initialStep);

  const updateStepInUrl = (step: keyof OnboardingSteps) => {
    const url = new URL(window.location.href);
    url.searchParams.set('step', step);
    window.history.replaceState({}, '', url.toString());
  };

  const handleSetOnboardingStep = (step: keyof OnboardingSteps) => {
    setOnboardingStep(step);
    updateStepInUrl(step);
  };

  const onboardingSteps: Record<keyof OnboardingSteps, React.ReactNode > = {
    password: <OnboardingStepPassword setOnboardingStep={handleSetOnboardingStep} />,
    roles: <OnboardingStepRoles setOnboardingStep={handleSetOnboardingStep} />,
    schule: <OnboardingStepSchule setOnboardingStep={handleSetOnboardingStep} />,
    bundesland: <OnboardingStepBundesland setOnboardingStep={handleSetOnboardingStep} />,
    schulstufe: <OnboardingStepSchulstufe setOnboardingStep={handleSetOnboardingStep} />,
    schulfaecher: 
      <OnboardingStepSchulfaecher 
        setInitialSelectedSubjects={setInitialSelectedSubjects}
        setOnboardingStep={handleSetOnboardingStep} />,
    wichtigkeit: <OnboardingStepWichtigkeit 
      initialSelectedSubjects={initialSelectedSubjects} 
      setOnboardingStep={handleSetOnboardingStep} />,
  };

  const step = onboardingSteps[onboardingStep];

  return (
    <Box 
      data-testid='onboarding-page' 
      sx={{
        display: 'flex',
        flexDirection: isDesktopScreen ? 'row' : 'column',
        width: '100%',
        minHeight: '100vh',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      {step}
    </Box>
  );
};

export default OnboardingPage;
